import React from 'react';
import { Icon } from '../../components/Icon';
import { Pagination } from '../../components/ui/Pagination';
import type { Deal } from '../../types/deal';
import { Link } from 'react-router-dom';
import { encryptId } from '../../utils/crypto';
import { formatDateUTC } from '../../utils/formatters';

interface TableProps {
  data: Deal[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onRefresh: () => void;
  // onGenerateQR: (personId: string, validationDate: string) => Promise<{ success: boolean, message?: string }>;
}

export const Table: React.FC<TableProps> = ({
  data,
  loading,
  currentPage,
  totalPages,
  pageSize,
  total,
  onPageChange
}) => {


  // const handleView = (empdealo: Empdealo) => {
  //   alert(`Ver detalles de: ${empdealo.nombre}`);
  //   // Implementar navegación a vista de detalles
  // };

  // const handleEdit = (empdealo: Empdealo) => {
  //   alert(`Editar empdealo: ${empdealo.nombre}`);
  //   // Implementar navegación a formulario de edición
  // };







  // const handleDelete = async (empdealo: Empdealo) => {
  //   if (window.confirm(`¿Estás seguro de eliminar a ${empdealo.nombre}?`)) {
  //     try {
  //       // Aquí iría la llamada a la API para eliminar
  //       // await visitasApi.deleteEmpdealo(empdealo.id);
  //       alert(`Empdealo ${empdealo.nombre} eliminado`);
  //       onRefresh();
  //     } catch (error) {

  //       alert(`Error al eliminar el empdealo: ${error}`);
  //     }
  //   }
  // };





  return (
    <div className="card p-1 lg:p-4">


      <div className="overflow-x-auto ">
        <table className="w-full border border-gray-200 ">
          <thead className="bg-gray-50 dark:bg-gray-700 ">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Modificado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Telefono
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Fuente
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Etapa
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Asignado
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {loading ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="loading" className="h-8 w-8 text-primary animate-spin" />
                    <span className="text-gray-600 dark:text-gray-300">Cargando visitas...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="users" className="w-12 h-12 text-gray-400" />
                    <span className="text-gray-500 dark:text-gray-400 text-lg">
                      No se encontraron deals
                    </span>
                    <span className="text-gray-400 dark:text-gray-500 text-sm">
                      Intenta ajustar los filtros de búsqueda
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((deal) => (
                <tr
                  key={deal.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
                >
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-xs font-medium text-gray-900 dark:text-white">
                        {formatDateUTC(deal.updated_at)}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="text-xs font-medium text-gray-900 dark:text-white">
                        <Link
                          to={`/admin/deals/detail/${encryptId(deal.id)}`}
                          className="text-blue-600 hover:underline"
                        >
                          {deal?.first_name || ""} {deal?.last_name || ""}
                        </Link>

                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal?.phone || ""}
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal?.email || ""}
                    </div>

                    {/* <button
                      onClick={() => handleStatus(person.status_persona_id, person.numero_persona)}
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${person.status_persona_id === '1'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      title="status"
                    > */}

                    {/* <button
                      onClick={() => handleOpenAccessManagementModal(person.identificacion, `${person.name_persona}`,person.status_persona_id, person.numero_persona)}
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${person.status_persona_id === '1'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      title="status"
                    >
                      {updating && updatePersonId === person.numero_persona ? (
                        <>
                          <Icon name="loading" className="w-4 h-4 animate-spin" />
                        </>
                      ) : (
                        <>
                        </>
                      )}

                      {person.status_persona_id === '1' ? "Activo" : "Inactivo"}
                    </button> */}
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal.source?.source ? deal.source?.source : ""  }
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal.process?.stage ? deal.process?.stage  : ""}
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal.status?.status ? deal.status?.status : ""}
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap">
                    <div className="text-xs text-gray-900 dark:text-white">
                      {deal && deal.user?.full_name ? deal.user?.full_name : "N/A"}
                    </div>
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center justify-center space-x-1">
                      {/* <button
                        // onClick={() => handleAddPhoto(person.identificacion)}
                        className="p-2 text-green-600 hover:text-green-900 hover:bg-green-50 dark:text-green-400 dark:hover:text-green-300 dark:hover:bg-green-900/20 rounded-lg transition-colors"
                        title="Eliminar"
                      >
                        <Icon name="trash" className="w-4 h-4" />
                      </button> */}

                      {/* <button
                        // onClick={() => handleAddPhoto(person.identificacion)}
                        className="p-2 text-green-600 hover:text-green-900 hover:bg-green-50 dark:text-green-400 dark:hover:text-green-300 dark:hover:bg-green-900/20 rounded-lg transition-colors"
                        title="Cargar Foto"
                      >
                        <Icon name="facial" className="w-4 h-4" />
                      </button> */}


                      {/* <button
                        // onClick={() => handleOpenQRModal(person.identificacion, `${person.name_persona}`)}
                        className="p-2 text-blue-600 hover:text-blue-900 hover:bg-blue-50 dark:text-blue-400 dark:hover:text-blue-300 dark:hover:bg-blue-900/20 rounded-lg transition-colors"
                        title="Lista de Accesos QR"
                      >
                        <Icon name="list" className="w-4 h-4" />
                      </button> */}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      { totalPages > 1 && (
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      )}

    </div>
  );
};